"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modes = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TransitionGroupContext = _interopRequireDefault(require("react-transition-group/TransitionGroupContext"));
var _Transition = require("./Transition");
// @ts-nocheck -- legacy react-transition-group adaptation; runtime behavior is covered by transition tests.

function areChildrenDifferent(oldChildren, newChildren) {
  if (oldChildren === newChildren) return false;
  if (/*#__PURE__*/_react.default.isValidElement(oldChildren) && /*#__PURE__*/_react.default.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
    return false;
  }
  return true;
}

/**
 * Enum of modes for SwitchTransition component
 * @enum { string }
 */
var modes = exports.modes = {
  out: 'out-in',
  in: 'in-out',
  together: 'together',
  none: 'none'
};
var callHook = (element, name, cb) => function () {
  element.props[name] && element.props[name](...arguments);
  cb();
};
var leaveRenders = {
  [modes.none]: _ref => {
    var current = _ref.current,
      changeState = _ref.changeState;
    return /*#__PURE__*/_react.default.cloneElement(current, {
      in: false,
      onExited: callHook(current, 'onExited', () => {
        changeState(_Transition.ENTERING, null);
      })
    });
  },
  [modes.out]: _ref2 => {
    var current = _ref2.current,
      changeState = _ref2.changeState;
    return /*#__PURE__*/_react.default.cloneElement(current, {
      in: false,
      onExited: callHook(current, 'onExited', () => {
        changeState(_Transition.ENTERING, null);
      })
    });
  },
  [modes.in]: _ref3 => {
    var current = _ref3.current,
      changeState = _ref3.changeState,
      children = _ref3.children;
    return [current, /*#__PURE__*/_react.default.cloneElement(children, {
      in: true,
      onEntered: callHook(children, 'onEntered', () => {
        changeState(_Transition.ENTERING);
      })
    })];
  },
  [modes.together]: _ref4 => {
    var current = _ref4.current,
      changeState = _ref4.changeState,
      children = _ref4.children;
    return [/*#__PURE__*/_react.default.cloneElement(current, {
      in: false
    }), /*#__PURE__*/_react.default.cloneElement(children, {
      in: true,
      onEntered: callHook(children, 'onEntered', () => {
        changeState(_Transition.ENTERED, /*#__PURE__*/_react.default.cloneElement(children, {
          in: true
        }));
      })
    })];
  }
};
var enterRenders = {
  [modes.none]: _ref5 => {
    var children = _ref5.children,
      changeState = _ref5.changeState;
    return /*#__PURE__*/_react.default.cloneElement(children, {
      in: true,
      onEntered: callHook(children, 'onEntered', () => {
        changeState(_Transition.ENTERED, /*#__PURE__*/_react.default.cloneElement(children, {
          in: true
        }));
      })
    });
  },
  [modes.out]: _ref6 => {
    var children = _ref6.children,
      changeState = _ref6.changeState;
    return /*#__PURE__*/_react.default.cloneElement(children, {
      in: true,
      onEntered: callHook(children, 'onEntered', () => {
        changeState(_Transition.ENTERED, /*#__PURE__*/_react.default.cloneElement(children, {
          in: true
        }));
      })
    });
  },
  [modes.in]: _ref7 => {
    var current = _ref7.current,
      children = _ref7.children,
      changeState = _ref7.changeState;
    return [/*#__PURE__*/_react.default.cloneElement(current, {
      in: false,
      onExited: callHook(current, 'onExited', () => {
        changeState(_Transition.ENTERED, /*#__PURE__*/_react.default.cloneElement(children, {
          in: true
        }));
      })
    }), /*#__PURE__*/_react.default.cloneElement(children, {
      in: true
    })];
  }
};

/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component,
 * the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter
 * and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */
class SwitchTransition extends _react.default.Component {
  constructor() {
    var _this;
    super(...arguments);
    _this = this;
    (0, _defineProperty2.default)(this, "state", {
      status: _Transition.ENTERED,
      current: null
    });
    (0, _defineProperty2.default)(this, "appeared", false);
    (0, _defineProperty2.default)(this, "changeState", function (status) {
      var current = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.current;
      _this.setState({
        status,
        current
      });
    });
  }
  componentDidMount() {
    this.appeared = true;
  }
  static getDerivedStateFromProps(props, state) {
    if (props.children == null) {
      return {
        current: null
      };
    }
    if (state.status === _Transition.ENTERING && props.mode === modes.in) {
      return {
        status: _Transition.ENTERING
      };
    }
    if (state.current && areChildrenDifferent(state.current, props.children)) {
      return {
        status: _Transition.EXITING
      };
    }
    return {
      current: /*#__PURE__*/_react.default.cloneElement(props.children, {
        in: true
      })
    };
  }
  render() {
    var _this$props = this.props,
      children = _this$props.children,
      mode = _this$props.mode,
      _this$state = this.state,
      status = _this$state.status,
      current = _this$state.current;
    var data = {
      children,
      current,
      changeState: this.changeState,
      status
    };
    var component;
    // eslint-disable-next-line default-case
    switch (status) {
      case _Transition.ENTERING:
        component = enterRenders[mode] ? enterRenders[mode](data) : enterRenders[modes.none](data);
        break;
      case _Transition.EXITING:
        component = leaveRenders[mode] ? leaveRenders[mode](data) : leaveRenders[modes.none](data);
        break;
      case _Transition.ENTERED:
        component = current;
    }
    return /*#__PURE__*/_react.default.createElement(_TransitionGroupContext.default.Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, component);
  }
}
SwitchTransition.propTypes = {
  /**
   * Transition modes.
   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
   * `in-out`: New element transitions in first, then when complete, the current element transitions out.
   *
   * @type {'out-in'|'in-out'|'together'}
   */
  mode: _propTypes.default.oneOf([modes.in, modes.out, modes.together]),
  /**
   * Any `Transition` or `CSSTransition` component.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element.isRequired])
};
SwitchTransition.defaultProps = {
  mode: modes.out
};
var _default = exports.default = SwitchTransition;